
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CategoryMasterGrid extends Serenity.EntityGrid<CategoryMasterRow, any> {
        protected getColumnsKey() { return 'OMS.CategoryMaster'; }
        protected getDialogType() { return CategoryMasterDialog; }
        protected getIdProperty() { return CategoryMasterRow.idProperty; }
        protected getLocalTextPrefix() { return CategoryMasterRow.localTextPrefix; }
        protected getService() { return CategoryMasterService.baseUrl; }
        protected getInsertPermission() { return CategoryMasterRow.insertPermission; }
        protected getUpdatePermission() { return CategoryMasterRow.updatePermission; }
        protected getDeletePermission() { return CategoryMasterRow.deletePermission; }
        protected useViewMode() { return true; }


        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}